import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const generateReportPDF = (reportData) => {
  // Initialize jsPDF with autotable plugin
  // eslint-disable-next-line new-cap
  const doc = new jsPDF();

  // Set document properties
  doc.setProperties({
    title: `Student Report - ${reportData.student_name}`,
    subject: "Academic Report",
    author: "School System"
  });

  // Add header
  doc.setFontSize(18);
  doc.setTextColor(40);
  doc.setFont("helvetica", "bold");
  doc.text("STUDENT ACADEMIC REPORT", 105, 20, { align: "center" });

  // Student information section
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text(`Student Name: ${reportData.student_name}`, 14, 35);
  doc.text(`Class: ${reportData.class_name}`, 14, 45);
  doc.text(`Term: ${reportData.term_name}`, 14, 55);

  // Subjects table
  autoTable(doc, {
    startY: 65,
    head: [["Subject", "CA1 (20)", "CA2 (20)", "Exam (60)", "Total (100)", "Grade"]],
    body: reportData.subjects.map(subject => [
      subject.name,
      subject.scores?.CA_scores?.CA1 || "-",
      subject.scores?.CA_scores?.CA2 || "-",
      subject.scores?.exam_score || "-",
      subject.scores?.total || "-",
      subject.scores?.grade || "-"
    ]),
    headStyles: {
      fillColor: [41, 128, 185],
      textColor: 255,
      fontStyle: "bold"
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245]
    },
    margin: { top: 10 }
  });

  // Extracurricular activities section
  let finalY = doc.lastAutoTable.finalY + 15;
  doc.setFont("helvetica", "bold");
  doc.text("EXTRACURRICULAR ACTIVITIES", 14, finalY);

  reportData.extras.forEach(extra => {
    if (extra.section_type === "grade") {
      finalY += 10;
      doc.setFont("helvetica", "bold");
      doc.text(`${extra.section_name.toUpperCase()}:`, 20, finalY);

      doc.setFont("helvetica", "normal");
      Object.entries(extra.section_value).forEach(([activity, grade]) => {
        finalY += 8;
        doc.text(`• ${activity}: ${grade}`, 25, finalY);
      });
    }
  });

  // Teacher's comment
  const teacherComment = reportData.extras.find(e => e.section_name === "teacher's comment");
  if (teacherComment) {
    finalY += 15;
    doc.setFont("helvetica", "bold");
    doc.text("TEACHER'S COMMENT:", 14, finalY);
    doc.setFont("helvetica", "normal");

    // Split comment into lines that fit the page width
    const splitComments = doc.splitTextToSize(teacherComment.section_value, 180);
    splitComments.forEach((line) => {
      finalY += 8;
      doc.text(line, 20, finalY);
    });
  }

  // Add footer
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.text(`Generated on ${new Date().toLocaleDateString()}`, 105, 285, { align: "center" });

  return doc;
};
